import { type Phase } from '@/types/jobs';

const PHASE_MAP: Record<string, Phase> = {
    mitigation: 'mitigation',
    remediation: 'remediation',
    restoration: 'restoration',
    reconstruction: 'restoration',
};

/**
 * Converts department/job phase variants to backend canonical phase values.
 * Returns null when a value cannot be safely mapped.
 */
export const toCanonicalPhase = (value?: string | null): Phase | null => {
    if (!value) return null;
    const key = value.trim().toLowerCase();
    return PHASE_MAP[key] ?? null;
};

/**
 * Returns Tailwind classes for styling a phase badge consistently across the app.
 */
export const getPhaseBadgeStyles = (phase?: string | null): string => {
    const canonical = toCanonicalPhase(phase);
    switch (canonical) {
        case 'mitigation':
            return 'bg-blue-500/10 text-blue-400 border-blue-500/30 shadow-[0_0_12px_rgba(59,130,246,0.15)]';
        case 'remediation':
            return 'bg-orange-500/10 text-orange-400 border-orange-500/30 shadow-[0_0_12px_rgba(249,115,22,0.15)]';
        case 'restoration':
            return 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30 shadow-[0_0_12px_rgba(16,185,129,0.15)]';
        default:
            return 'bg-surface-active text-text-muted border-divider-subtle';
    }
};
